// src/MyClinicEvents.js
import React, { useEffect, useState } from "react";
import styles from "./ActiveClinicEvents.module.css"; // reuse for layout consistency
import { auth, db } from "./firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";

const formatTime = (timeStr) => {
  const [hour, minute] = timeStr.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
};


function MyClinicEvents() {
  const [userEmail, setUserEmail] = useState(null);
  const [signedUpEvents, setSignedUpEvents] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [eventToCancel, setEventToCancel] = useState(null);

  useEffect(() => {
    const fetchSignedUpEvents = async () => {
      const user = auth.currentUser;
      if (!user) return;
      setUserEmail(user.email);

      const querySnapshot = await getDocs(collection(db, "clinic_events"));
      const allEvents = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const userEvents = allEvents.filter((event) => (event.signedUp || []).includes(user.email));
      setSignedUpEvents(userEvents);
    };

    fetchSignedUpEvents();
  }, []);

  const handleCancel = async () => {
    if (!eventToCancel || !userEmail) return;

    const eventRef = doc(db, "clinic_events", eventToCancel);
    const updatedEvent = signedUpEvents.find((e) => e.id === eventToCancel);
    const updatedSignedUp = (updatedEvent.signedUp || []).filter((email) => email !== userEmail);

    await updateDoc(eventRef, { signedUp: updatedSignedUp });

    setSignedUpEvents((prev) => prev.filter((e) => e.id !== eventToCancel));
    setShowConfirmModal(false);
    setEventToCancel(null);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>📋 My Clinic Events</h2>

      {showConfirmModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.confirmModal}>
            <h3>Cancel Sign-Up</h3>
            <p>Are you sure you want to cancel your sign-up for this event?</p>
            <div className={styles.modalButtons}>
              <button className={styles.confirmBtn} onClick={handleCancel}>
                Yes, Cancel It
              </button>
              <button className={styles.cancelBtn} onClick={() => setShowConfirmModal(false)}>
                Go Back
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={styles.cardPane}>
        {signedUpEvents.length === 0 ? (
          <p>You haven't signed up for any events yet.</p>
        ) : (
          signedUpEvents.map((event) => (
            <div key={event.id} className={styles.eventCard}>
              <div className={styles.cancelButtonWrapper}>
                <button
                  onClick={() => {
                    setEventToCancel(event.id);
                    setShowConfirmModal(true);
                  }}
                  className={styles.cancelBtn}
                >
                  Cancel
                </button>
              </div>
              <h3>{event.title}</h3>
<p><strong>📍 Location:</strong> {event.location}</p>
<p><strong>🏫 Address:</strong> {event.address}</p> {/* if this field exists */}
<p><strong>📅 Date:</strong> {event.date}</p>
<p><strong>🕒 Time:</strong> {formatTime(event.startTime)} – {formatTime(event.endTime)}</p>
<p><strong>👥 Max Students:</strong> {event.maxStudents}</p>
<p><strong>🧾 Notes:</strong> {event.notes || "—"}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default MyClinicEvents;
